
/*
* Pagina Account/ModificaEmailPassword (view Common) con campi DevExtreme.
* Sostituisce CheckFormModificaAccount di common.js per questa pagina: CheckFormModificaAccount resta per
* l'override Tipo38 che usa ancora input Bootstrap.
* Le etichette arrivano dalla view in MEP_etichette (lette lato server).
* Claude
*/

var MEP_CAMPI = ['oldpassword', 'newpassword', 'confermanewpassword'];

/**
* Restituisce l'istanza del TextBox DevExtreme con l'id indicato.
* Claude
* @param {string} id
*/
function MEP_Istanza(id) {
    var el = document.getElementById(id);
    return el && typeof DevExpress !== 'undefined' ? DevExpress.ui.dxTextBox.getInstance(el) : null;
}

/**
* Valore del campo password (con trim, come in CheckFormModificaAccount).
* Claude
* @param {string} id
*/
function MEP_Valore(id) {
    var istanza = MEP_Istanza(id);
    var valore = istanza ? istanza.option('value') : '';
    return (valore || '').trim();
}

/**
* Segna il campo come non valido, con messaggio opzionale nel tooltip del widget.
* Claude
*/
function MEP_SegnaErrore(id, messaggio) {
    var istanza = MEP_Istanza(id);
    if (istanza) {
        istanza.option({
            validationStatus: 'invalid',
            validationErrors: messaggio ? [{ message: messaggio }] : []
        });
    }
}

/**
* Riporta il campo allo stato valido.
* Claude
*/
function MEP_SegnaValido(id) {
    var istanza = MEP_Istanza(id);
    if (istanza) {
        istanza.option({ validationStatus: 'valid', validationErrors: [] });
    }
}

/**
* Mostra il messaggio d'errore sotto i campi (vuoto = nasconde).
* Claude
*/
function MEP_Messaggio(testo) {
    $('#chkpassword').html(testo || '');
}

/**
* Mostra/nasconde il testo della password (pulsante "occhio" del TextBox).
* Claude
* @param {any} e - evento click del pulsante
* @param {string} id - id del TextBox
*/
function MEP_MostraPassword(e, id) {
    var istanza = MEP_Istanza(id);
    if (!istanza) {
        return;
    }
    var visibile = istanza.option('mode') === 'text';
    istanza.option('mode', visibile ? 'password' : 'text');
    e.component.option('icon', visibile ? 'eyeopen' : 'eyeclose');
}

/**
* Regex della password sicura in base al sito (stesse regole di CheckPassword in common.js).
* Claude
*/
function MEP_RegexSicura(idsito) {
    return idsito == 46 ? strongPasswordAccount : strongPassword;
}

/**
* Toglie l'errore dal campo appena l'utente scrive.
* Claude
*/
function MEP_TogliErrore(e) {
    if (e.value) {
        e.component.option({ validationStatus: 'valid', validationErrors: [] });
    }
}

/**
* Controllo durante la digitazione su nuova password e conferma: corrispondenza.
* Claude
*/
function MEP_ControlloLive(e) {
    MEP_TogliErrore(e);

    var nuova = MEP_Valore('newpassword');
    var conferma = MEP_Valore('confermanewpassword');

    if (nuova && conferma && nuova !== conferma) {
        MEP_SegnaErrore('confermanewpassword', MEP_etichette.nonCoincidono);
        MEP_Messaggio(MEP_etichette.nonCoincidono);
    }
    else {
        if (conferma) {
            MEP_SegnaValido('confermanewpassword');
        }
        MEP_Messaggio('');
    }
}

/**
* Valida il form e salva la nuova password via AJAX (stessa chiamata di CheckFormModificaAccount).
* Claude
* @param {number} idsito
* @returns {boolean} sempre false: il salvataggio avviene via AJAX, non con il submit del form
*/
function ValidaModificaEmailPassword(idsito) {
    try {
        var valori = {};
        MEP_CAMPI.forEach(function (id) {
            valori[id] = MEP_Valore(id);
            MEP_SegnaValido(id);
        });
        MEP_Messaggio('');

        var formstate = true;
        var compilati = MEP_CAMPI.filter(function (id) { return valori[id] !== ''; });

        if (compilati.length < MEP_CAMPI.length) {
            // tutti vuoti oppure compilati solo in parte: i campi vuoti sono obbligatori
            MEP_CAMPI.forEach(function (id) {
                if (valori[id] === '') {
                    MEP_SegnaErrore(id, MEP_etichette.obbligatorio);
                }
            });
            MEP_Messaggio(MEP_etichette.vuota);
            formstate = false;
        }
        else if (idsito > 0 && !MEP_RegexSicura(idsito).test(valori.newpassword)) {
            MEP_SegnaErrore('newpassword', MEP_etichette.nonSicura);
            MEP_Messaggio(MEP_etichette.nonSicura);
            formstate = false;
        }
        else if (valori.newpassword !== valori.confermanewpassword) {
            MEP_SegnaErrore('confermanewpassword', MEP_etichette.nonCoincidono);
            MEP_Messaggio(MEP_etichette.nonCoincidono);
            formstate = false;
        }

        if (formstate == false) {
            return false;
        }

        waitingBS.Show();
        var params = {
            email: undefined,
            vecchiapassword: valori.oldpassword,
            password: valori.newpassword,
            confermapassword: valori.confermanewpassword
        };

        mainController.CallServiceAsync('/Account/ModificaEmailOPassword', params)
            .then(result => {
                try {
                    if (result) {
                        if (result.esito == Costanti.ESITO_OK) {
                            setTimeout(function () {
                                location.href = '/Account/Home';
                            }, 1500);
                        }
                        else {
                            waitingBS.Hide();
                        }
                        mainController.NotifyMessage(result.responseText, result.NotifyColor);
                    }
                    else {
                        mainController.NotifyMessage(MEP_etichette.erroreSalvataggio, Costanti.NOTIFY_COLOR_ERROR);
                        waitingBS.Hide();
                    }
                }
                catch (error) {
                    console.log(error);
                    mainController.NotifyMessage(MEP_etichette.erroreGenerico, Costanti.NOTIFY_COLOR_ERROR);
                    waitingBS.Hide();
                }
            })
            .catch(error => {
                console.log(error);
                mainController.NotifyMessage(MEP_etichette.erroreGenerico, Costanti.NOTIFY_COLOR_ERROR);
                waitingBS.Hide();
            });
    }
    catch (error) {
        console.log(error);
        waitingBS.Hide();
    }
    return false;
}
